<!-- 课后问答 -->

<template>
  <div class="main">
    <back />
    <div class="flex title">
      <div class="">课后问答：</div>
      <div class="">
        <el-button class="btn" type="primary" @click="handleAdd">新增</el-button>
        <el-button class="btn" type="primary" @click="downloadTemplate">下载模板</el-button>
        <el-button class="btn" type="primary" @click="importShow = true">批量上传</el-button>
      </div>
    </div>
    <!-- 表格 -->
    <div class="g_table">
      <el-table :data="tableData" style="width: 100%" max-height="540" row-key="id">
        <el-table-column label="序号" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.$index + 1 + (currentPage - 1) * pageSize }}
          </template>
        </el-table-column>
        <el-table-column min-width="210" show-overflow-tooltip prop="content" label="题目"></el-table-column>
        <el-table-column min-width="210" show-overflow-tooltip prop="answerAnalyze" label="答案解析"></el-table-column>
        <el-table-column min-width="210" show-overflow-tooltip prop="points" label="积分"></el-table-column>
        <el-table-column label="操作" header-align="center" align="center" width="300" fixed="right">
          <template slot-scope="scope">
            <el-button class="btn" type="primary" plain @click="handleCheck(scope.row)">查看</el-button>
            <el-button class="btn" type="primary" plain @click="handleModify(scope.row)">修改</el-button>
            <el-button class="btn" type="danger" plain @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="pageSizeArr"
      layout="prev, pager, next, jumper, sizes, total" :total="totalItemsCount"></el-pagination>

    <!-- 新增/修改课后问答 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" @close="handleCloseDialog">
      <el-form :model="ruleForm" ref="ruleForm" :rules="rules" class="demo-ruleForm" label-width="150px">
        <el-row>
          <el-col :span="24">
            <el-form-item label="问题：" prop="content">
              <el-input v-model="ruleForm.content" placeholder="请输入" :readonly="isViewMode"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="积分：" prop="points">
              <el-input v-model="ruleForm.points" placeholder="请输入" :readonly="isViewMode"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item class="options" label="选项：" prop="optionList">
          <div v-for="(option, index) in ruleForm.optionList" :key="index" class="option-item">
            <el-input v-model="option.content" placeholder="请输入选项内容" @input="handleOptionInput"
              :readonly="isViewMode"></el-input>
            <el-radio v-model="option.isCorrect" :label="true" size="medium" @change="handleCorrectChange(index)"
              :disabled="isViewMode">
              是否正确答案
            </el-radio>
            <div class="icon-group" v-if="!isViewMode">
              <img v-if="
                (ruleForm.optionList.length === 3 && index === 2) ||  // 3个选项时，第3个显示减号
                (ruleForm.optionList.length === 4 && index === 3)    // 4个选项时，第4个显示减号
              " src="../../../assets/img/minus.png" width="20" height="20" class="icon" @click="handleRemoveOption" />
              <img v-if="
                (ruleForm.optionList.length === 2 && index === 1) ||  // 2个选项时，第2个显示加号
                (ruleForm.optionList.length === 3 && index === 2)    // 3个选项时，第3个显示加号
              " src="../../../assets/img/add.png" width="20" height="20" class="icon" @click="handleAddOption" />
            </div>
          </div>
        </el-form-item>
        <el-row>
          <el-col :span="24">
            <el-form-item label="答案解析：" prop="answerAnalyze">
              <el-input v-model="ruleForm.answerAnalyze" placeholder="请输入" type="textarea" :rows="4" resize="none"
                :readonly="isViewMode"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" v-if="!isViewMode">
        <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 批量上传弹窗 -->
    <el-dialog title="批量上传" :visible.sync="importShow" :before-close="onImportCancel">
      <el-form label-width="120px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="上传附件" required>
              <el-upload :action="apiBaseUrl" :headers="apiHeaders" :file-list="importFiles" accept=".xlsx,.xls"
                :on-change="beforeUpload" :auto-upload="false" :limit="1" :on-exceed="handleExceed"
                :on-remove="handleRemove">
                <el-button size="small" type="primary">点击上传</el-button>
                <div slot="tip" class="el-upload__tip" style="color: red">提示：只能上传"xlsx"、"xls"文件，且不超过5MB</div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer">
        <el-button @click="onImportCancel">取 消</el-button>
        <el-button type="primary" @click="submitFormImport('importRuleForm')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 导入弹窗数据
      apiBaseUrl: this.$axios.defaults.baseURL + this.$api.importQuestionInfo,
      apiHeaders: {
        token: this.$store.state.token,
      },
      importShow: false,
      importFiles: [], //文件列表

      bizId: '',
      type: '',
      isViewMode: false, // 查看模式标记：true-查看（不可改），false-编辑（可改）
      // 弹窗
      dialogVisible: false,
      dialogTitle: "",
      tableData: [],
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示的行数
      pageSizeArr: [10, 20, 50], // 每页显示的行数(可选)
      totalItemsCount: 0, // 总记录数（需要从后端获取）
      ruleForm: {
        content: '',
        points: '',
        optionList: [
          { content: '', isCorrect: false },
          { content: '', isCorrect: false }
        ],
        answerAnalyze: '',
        id: '',
      },
      rules: {
        content: [{
          required: true,
          message: '请输入问题',
          trigger: 'blur'
        }],
        points: [{
          required: true,
          message: '请输入积分',
          trigger: 'blur'
        },
        {
          pattern: /^\d+(\.\d{1,2})?$/,
          message: "只能输入数字",
          trigger: "blur",
        },],
        optionList: [{
          required: true,
          validator: (rule, value, callback) => {
            if (value.length < 2) {
              return callback(new Error('至少需要2个选项'));
            }
            const hasEmpty = value.some(item => !item.content.trim());
            if (hasEmpty) {
              return callback(new Error('选项内容不能为空'));
            }
            const correctCount = value.filter(item => item.isCorrect).length;
            if (correctCount === 0) {
              return callback(new Error('请选择一个正确答案'));
            }
            if (correctCount > 1) {
              return callback(new Error('只能选择一个正确答案'));
            }
            callback(); // 验证通过
          },
          trigger: 'input,change,blur'
        }]
      }
    }
  },
  created() {
    this.bizId = this.$route.query.id
    this.type = this.$route.query.type
    this.getList()
  },
  methods: {
    // 获取列表
    getList() {
      this.$axios
        .post(this.$api.selectQuestionInfoPage, {
          page: this.currentPage,
          pageSize: this.pageSize,
          bizId: this.bizId,
          type: this.type,
        })
        .then(res => {
          if (res.code == 100) {
            this.tableData = res.result.list || []
            this.totalItemsCount = res.result.totalCount
          }
        })
        .catch(err => {
          this.$message.error(err.desc)
        })
    },
    handleCheck(row) {
      this.dialogVisible = true;
      this.dialogTitle = '查看';
      this.isViewMode = true;
      this.ruleForm = JSON.parse(JSON.stringify(row));
      if (!this.ruleForm.optionList) {
        this.ruleForm.optionList = [
          { content: '', isCorrect: false },
          { content: '', isCorrect: false }
        ];
      } else {
        this.ruleForm.optionList.forEach(option => {
          option.isCorrect = option.isCorrect === 1 || option.isCorrect === true;
        });
      }
    },
    // 选项内容输入时触发校验
    handleOptionInput() {
      this.$refs.ruleForm.validateField('optionList');
    },
    handleCorrectChange(index) {
      this.ruleForm.optionList = this.ruleForm.optionList.map((item, i) => ({
        ...item,
        isCorrect: i === index // 仅当前索引选项为true
      }));
      this.$refs.ruleForm.validateField('optionList');
    },
    handleAddOption() {
      const currentLen = this.ruleForm.optionList.length;
      if (currentLen < 4) {
        this.ruleForm.optionList.push({ content: '', isCorrect: false });
      }
    },
    handleRemoveOption() {
      const currentLen = this.ruleForm.optionList.length;
      if (currentLen > 2) {
        this.ruleForm.optionList.pop();
        this.$nextTick(() => {
          this.$refs.ruleForm.validateField('optionList');
        });
      }
    },

    resetForm() {
      this.ruleForm = {
        question: '',
        points: '',
        answerAnalysis: '',
        id: '',
        optionList: [
          { content: '', isCorrect: false },
          { content: '', isCorrect: false }
        ]
      };
      this.$refs.ruleForm.resetFields();
    },
    // 新增
    handleAdd() {
      this.dialogTitle = '新增';
      this.dialogVisible = true
      this.isViewMode = false; // 编辑模式
    },
    // 修改
    handleModify(row) {
      this.dialogVisible = true;
      this.dialogTitle = '修改';
      this.isViewMode = false; // 编辑模式
      this.ruleForm = JSON.parse(JSON.stringify(row));
      if (!this.ruleForm.optionList) {
        this.ruleForm.optionList = [
          { content: '', isCorrect: false },
          { content: '', isCorrect: false }
        ];
      } else {
        this.ruleForm.optionList.forEach(option => {
          option.isCorrect = option.isCorrect === 1 || option.isCorrect === true;
        });
      }
    },
    // 关闭弹窗
    handleCloseDialog() {
      this.dialogVisible = false;
      this.dialogTitle = '';
      this.resetForm();
    },
    // 表单校验
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          const formData = {
            content: this.ruleForm.content,
            question: this.ruleForm.question,
            points: this.ruleForm.points,
            answerAnalyze: this.ruleForm.answerAnalyze,
            dtoList: this.ruleForm.optionList.map(option => ({
              content: option.content,
              isCorrect: option.isCorrect ? 1 : 0
            })),
            bizId: this.bizId,
            type: this.type,
          };
          if (this.dialogTitle == '修改') {
            formData.id = this.ruleForm.id
            this.$axios
              .post(this.$api.updateQuestionInfo, formData)
              .then(res => {
                if (res.code == 100) {
                  this.$message.success(res.desc)
                  this.handleCloseDialog()
                  this.getList()
                }
              })
              .catch(err => {
                this.$message.error(err.desc)
              })
          } else {
            // 否则调用添加接口 
            this.$axios
              .post(this.$api.insertQuestionInfo, formData)
              .then(res => {
                if (res.code == 100) {
                  this.$message.success(res.desc)
                  this.handleCloseDialog()
                  this.getList()
                }
              })
              .catch(err => {
                this.$message.error(err.desc)
              })
          }
        } else {
          console.log("error submit!!")
          return false
        }
      })
    },
    // 删除
    handleDelete(row) {
      this.$confirm("是否确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.$axios
            .get(this.$api.deleteQuestionInfo, {
              params: {
                id: row.id,
                type: this.type
              }
            })
            .then(res => {
              if (res.code == 100) {
                this.$message.success(res.desc)
                this.getList()
              }
            })
            .catch(err => {
              this.$message.error(err.desc)
            })
        })
        .catch(() => {
          this.$message("取消删除")
        })
    },
    // 清空
    clearData() {
      this.tableData = [];
      this.currentPage = 1;
    },
    // 搜索
    onSearch() {
      this.clearData();
      this.getList();
    },
    // 切换每页显示的条数
    handleSizeChange(e) {
      this.pageSize = e;
      this.onSearch();
    },
    // 换页
    handleCurrentChange(e) {
      this.tableData = [];
      this.currentPage = e;
      this.getList();
    },
    // 模板下载
    downloadTemplate() {
      const link = document.createElement("a")
      link.style.display = "none"
      link.href = "https://lzsg.ganmiaoedu.com/files/excel/课后问答导入模板.xlsx"
      link.download = "课后问答导入模板.xlsx"
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    // 导入弹窗关闭
    onImportCancel() {
      this.importShow = false
      this.importFiles = []
    },
    beforeUpload(file) {
      const suffixArr = ["xlsx", "xls"]
      const maxSize = 1024 * 1024 * 5
      if (!suffixArr.includes(file.name.split(".").pop())) {
        this.$message.error(`只能上传"xlsx"、"xls"文件`)
        this.importFiles = []
        return false
      }
      if (file.size > maxSize) {
        this.$message.error("附件不能超过5M")
        this.importFiles = []
        return false
      }
      this.importFiles.push(file.raw)
    },
    handleExceed() {
      this.$message.warning(`只能上传一个文件！`)
    },
    handleRemove() {
      this.importFiles = []
    },
    // 导入表单校验
    submitFormImport() {
      if (!this.importFiles || this.importFiles.length == 0) {
        return this.$message.warning("请先上传文件")
      }
      let parmas = new FormData()
      parmas.append("file", this.importFiles[0])
      parmas.append("bizId", this.bizId)
      parmas.append("type ", this.type)
      this.$axios.post(this.$api.importQuestionInfo, parmas).then(res => {
        if (res.code == 100) {
          this.$message.success(res.desc)
          this.onImportCancel()
          this.getList()
        }
      }).catch(err => {
        this.$message.error(err.desc)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.main {
  .flex {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .title {
    font-size: 18px;
    padding-bottom: 15px;
    padding-left: 20px;
    margin-bottom: 10px;
    font-weight: bold;
    // border-bottom: 1px solid #E5E7E6;
  }
}

// 对话框
::v-deep .el-dialog {

  .options {

    .el-input,
    .el-input__inner {
      width: 400px;
      margin-right: 15px;
    }

    .option-item {
      display: flex;
      align-items: center;
      gap: 15px;
      margin-bottom: 10px;
    }

    .radio-group {
      white-space: nowrap;
    }

    .icon-group {
      display: flex;
      gap: 10px;
      margin-left: 10px;
    }

    .icon {
      cursor: pointer;
      vertical-align: middle;
    }
  }

  .el-input,
  .el-input__inner,
  .el-textarea {
    width: 700px;
  }

  .el-form-item__label {
    color: #272727;
    font-size: 16px;
    padding-right: 30px;
  }

}
</style>
